import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import * as types from './types';
import fetchProductList from '~/services/layer';
import { fetchProducts } from '~/services/product';
import { FAST_TIMER } from '~/const/timers';

function timer() {
  return _timer.apply(this, arguments);
}

function _timer() {
  _timer = _asyncToGenerator(function* () {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve();
      }, FAST_TIMER);
    });
  });
  return _timer.apply(this, arguments);
}

export default {
  fetchProducts(store, payload) {
    var _this = this;

    return _asyncToGenerator(function* () {
      store.commit(types.SET_LOADING_LAYER, true);
      var currentState = store.state;

      if (payload.security) {
        yield timer();
      }

      if (payload.payload !== currentState.latest) {
        return;
      }

      var productList = yield fetchProductList(_this, payload.payload);
      var products = yield fetchProducts(_this, productList);

      if (payload.payload !== currentState.latest) {
        return;
      }

      store.commit(types.SET_LAYER_PRODUCTS, products);
      productList = null;
      products = null;
      store.commit(types.SET_LOADING_LAYER, false);
    })();
  },

  resetProducts(_ref) {
    return _asyncToGenerator(function* () {
      var {
        commit
      } = _ref;
      commit(types.RESET_LAYER_PRODUCTS, []);
    })();
  },

  setCurrentLayer(store, payload) {
    return _asyncToGenerator(function* () {
      var data = payload;
      store.commit(types.SET_CURRENT_LAYER, data);
      data = null;
    })();
  },

  appendItems(store, payload) {
    return _asyncToGenerator(function* () {
      store.commit(types.APPEND_ITEMS, payload);
    })();
  }

};